export default {"src":"/_next/static/media/enerflo-system-details-icon.4664a0b1.svg","height":90,"width":84};